import * as THREE from 'three';

/** @param material shared, tier-tinted material owned by Village.ts */
export function createRiver(material: THREE.Material, width = 3, length = 14): THREE.Mesh {
  const river = new THREE.Mesh(new THREE.PlaneGeometry(width, length, 1, 1), material);
  river.rotation.x = -Math.PI / 2;
  river.position.y = 0.01;
  river.receiveShadow = true;
  return river;
}
